import { SaleCreateError } from '../queries/sale_create'
import { SaleCreateErrorCode } from '../models/sale.constants'

export class SaleCreateCustomError extends Error {
  public customError: SaleCreateError

  constructor(message: string, code: SaleCreateErrorCode) {
    super(message)
    this.customError = {
      code,
      message,
    }
  }
}
